import React, { FC, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UitkTab, UitkTabs, UitkTabsType } from 'uitk-react-tabs';
import { HeaderElementFragment, HeaderLinkFragment, UiLinkTarget } from '../../graphql/__generated__/types';
import { getActiveTabIndex, filterHeaderLinks } from 'utils/header-navigation';
import useNavigationParams from 'hooks/useNavigationParams';
import { getPathName } from '../../utils/common';

interface NavbarProps {
  primaryNavigation: Array<HeaderElementFragment>;
  secondaryNavigation?: Array<HeaderElementFragment>;
}

const renderTabs = (tabs: Array<HeaderLinkFragment>, isSecondaryTabs?: boolean) =>
  tabs.map((tab, tabIndex: number) => {
    return (
      <UitkTab
        targetURI={getTargetUri(tab.action.target === UiLinkTarget.EXTERNAL, tab.action.resource.value)}
        className={isSecondaryTabs && tabIndex === 0 ? 'secondary-header-tabs' : ''}
        name={tab.text}
        id={tab.action.resource.value}
        key={tab.action.resource.value}
      />
    );
  });

const getTargetUri = (isExternal: boolean, path: string) => (isExternal ? path : getPathName(path));
const HeaderNavbar: FC<NavbarProps> = ({ primaryNavigation, secondaryNavigation }) => {
  const primaryNavigationLinks = filterHeaderLinks(primaryNavigation);
  const secondaryNavigationLinks = filterHeaderLinks(secondaryNavigation);
  const headerNavigationLinks = [...primaryNavigationLinks, ...secondaryNavigationLinks];

  const { tabId, documentId } = useNavigationParams();
  const { push } = useHistory();

  const initialTabIndex = getActiveTabIndex(tabId, documentId, headerNavigationLinks);

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(initialTabIndex);

  const onTabSelectHandler = (tabIndex: number) => {
    setSelectedTabIndex(tabIndex);
    const activeTab = headerNavigationLinks[tabIndex];
    if (activeTab.action.target === UiLinkTarget.EXTERNAL) {
      return window.open(activeTab.action.resource.value);
    }
    push(getPathName(activeTab.action.resource.value));
  };

  useEffect(() => {
    setSelectedTabIndex(getActiveTabIndex(tabId, documentId, headerNavigationLinks));
  }, [tabId, documentId]);

  return (
    <div className="navbar-tabs">
      <UitkTabs selectedTab={selectedTabIndex} onTabSelect={onTabSelectHandler} tabsType={UitkTabsType.NATURAL}>
        {renderTabs(primaryNavigationLinks)}
        {renderTabs(secondaryNavigationLinks, true)}
      </UitkTabs>
    </div>
  );
};

export default HeaderNavbar;
